export interface GasData {
  maxFeePerGas: string
  maxPriorityFeePerGas: string
  erc20ApproveGas: string
  erc20TransferGas: string
  ethDepositGas: string
  ethTransferGas: string
  erc20DepositGas: string
}

export enum EthTransactionType {
  SEND_ETH = 'sendEth',
  APPROVE = 'approve',
  TRANSFER = 'transfer',
  TRANSFER_FROM = 'transferFrom',
  CONTRACT_CALL = 'contractCall',
}

export interface EthTransaction {
  to: string
  from: string
  value: string
  data?: string
  gas?: string
  gasLimit?: string
}

interface AbiParameter {
  internalType: string
  name: string
  type: string
}

export interface ContractInfo {
  gasLimit?: bigint
  name?: string
  functionType?: 'payable' | 'nonpayable' | 'view' | 'pure'
  inputs?: AbiParameter[]
  params?: {
    [key: string]: unknown
    __length__: number
  }
  value?: string
  contractAddress: string
}
